import classnames from 'classnames'

export interface FieldProps {
  children: React.ReactNode
  className?: string
  description?: React.ReactNode
  error?: React.ReactNode
  htmlFor?: string
  label: React.ReactNode
}

export default function Field({
  children,
  className,
  description,
  error,
  htmlFor,
  label
}: FieldProps) {
  const labelContent = (
    <span className="text-xs font-medium uppercase tracking-wide text-zinc-600">
      {label}
    </span>
  )

  return (
    <div className={classnames('space-y-1', className)}>
      {htmlFor ? <label htmlFor={htmlFor}>{labelContent}</label> : labelContent}
      {description ? (
        <p className="text-xs text-zinc-500">{description}</p>
      ) : null}
      {children}
      {error ? <p className="text-xs text-rose-600">{error}</p> : null}
    </div>
  )
}
